heightDiv = function () {
  alert();
  var element = document.getElementById("heightDiv");
  element.style.height = "600px";
};

openMenu = function () {
  document.body.classList.add("menu-expanded");
};
closeMenu = function () {
  document.body.classList.remove("menu-expanded");
};

// Get the elements with class="column"
var elements = document.getElementsByClassName("box-car");
var i;
// List View
listView = function () {
  for (i = 0; i < elements.length; i++) {
    elements[i].classList.add("full-box");
  }
};

// Grid View
gridView = function () {
  for (i = 0; i < elements.length; i++) {
    elements[i].classList.remove("full-box");
  }
};

function onScroll() {
  if (scrollY > 0) {
    document.body.classList.add("sticky-header");
  } else {
    document.body.classList.remove("sticky-header");
  }
}

window.onscroll = function () {
  onScroll();
  showBackToTopButtonOnScroll();
};

ScrollReveal({
  origin: "top",
  distance: "30px",
  duration: 700,
}).reveal(`
  #list-car, #financing, #options .box-card, #company-vision, #carousel-cars`);

$(document).ready(function () {
  $(".financing-owl").owlCarousel({
    loop: true,
    margin: 10,
    dots: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: true,
      },
      600: {
        items: 2,
        nav: true,
      },
      900: {
        items: 3,
        nav: true,
      },
      1000: {
        items: 4,
        nav: true,
        loop: false,
      },
    },
  });

  $(".slider-car-owl").owlCarousel({
    loop: true,
    margin: 10,
    dots: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: true,
        loop: true,
      },
      600: {
        items: 2,
        nav: true,
        loop: true,
      },
      900: {
        items: 3,
        nav: true,
        loop: true,
      },
      1000: {
        items: 3,
        nav: true,
        loop: true,
      },
    },
  });

  //Mascara Telefone
  var SPMaskBehavior = function (val) {
      return val.replace(/\D/g, "").length === 11
        ? "(00) 00000-0000"
        : "(00) 0000-00009";
    },
    spOptions = {
      onKeyPress: function (val, e, field, options) {
        field.mask(SPMaskBehavior.apply({}, arguments), options);
      },
    };

  $(".phone_mask").mask(SPMaskBehavior, spOptions);

  //Validar from contato
  jQuery.extend(jQuery.validator.messages, {
    required: "Este campo &eacute; requerido.",
    remote: "Por favor, corrija este campo.",
    email:
      "Por favor, forne&ccedil;a um endere&ccedil;o eletr&ocirc;nico v&aacute;lido.",
    url: "Por favor, forne&ccedil;a uma URL v&aacute;lida.",
    date: "Por favor, forne&ccedil;a uma data v&aacute;lida.",
    dateISO: "Por favor, forne&ccedil;a uma data v&aacute;lida (ISO).",
    number: "Por favor, forne&ccedil;a um n&uacute;mero v&aacute;lido.",
    digits: "Por favor, forne&ccedil;a somente d&iacute;gitos.",
    creditcard:
      "Por favor, forne&ccedil;a um cart&atilde;o de cr&eacute;dito v&aacute;lido.",
    equalTo: "Por favor, forne&ccedil;a o mesmo valor novamente.",
    accept:
      "Por favor, forne&ccedil;a um valor com uma extens&atilde;o v&aacute;lida.",
    maxlength: jQuery.validator.format(
      "Por favor, forne&ccedil;a n&atilde;o mais que {0} caracteres."
    ),
    minlength: jQuery.validator.format(
      "Por favor, forne&ccedil;a ao menos {0} caracteres."
    ),
    rangelength: jQuery.validator.format(
      "Por favor, forne&ccedil;a um valor entre {0} e {1} caracteres de comprimento."
    ),
    range: jQuery.validator.format(
      "Por favor, forne&ccedil;a um valor entre {0} e {1}."
    ),
    max: jQuery.validator.format(
      "Por favor, forne&ccedil;a um valor menor ou igual a {0}."
    ),
    min: jQuery.validator.format(
      "Por favor, forne&ccedil;a um valor maior ou igual a {0}."
    ),
  });

  $("form[name='form-contact']").validate({
    rules: {
      // The key name on the left side is the name attribute
      // of an input field. Validation rules are defined
      // on the right side
      name: "required",
      email: {
        required: true,
        // Specify that email should be validated
        // by the built-in "email" rule
        email: true,
      },
      phone: "required",
      subject: {
        required: true,
      },
      message: {
        required: true,
      },
    },
    submitHandler: function (form) {
      form.submit();
    },
  });
});

$("#toggleexpansivel").click(function () {
  $("#expanded-filter").toggleClass("expanded-form-hidden");
  $('.banners-left').toggleClass("expanded-form-hidden");
});


function showBackToTopButtonOnScroll() {
  if (scrollY > 550) {
    backToTopButton.classList.add('show')
  } else {
    backToTopButton.classList.remove('show')
  }
}
